// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1ab5ba500e6ee6699d13","655":"2371da60636300fa22e6"}[chunkId] + ".js";
};